import { render, staticRenderFns } from "./groups-top-bar-group-view.vue?vue&type=template&id=fd0d0d2a&"
import script from "./groups-top-bar-group-view.vue?vue&type=script&lang=js&"
export * from "./groups-top-bar-group-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports